export default __webpack_public_path__ + "static/media/DamasoNo17.48f9c290.jpg";